
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

const Conclusion: React.FC = () => {
  return (
    <section>
      <h2 className="text-2xl font-bold text-itmgmt-dark-blue mb-6">Taking Your Real Estate Agency to the Next Level</h2>
      
      <p className="mb-4 text-gray-700 leading-relaxed">
        Technology has become a critical differentiator in the competitive real estate market. 
        Agencies that embrace and effectively implement the right technology solutions gain significant 
        advantages in efficiency, client experience, and ultimately, transaction volume and revenue.
      </p>
      
      <p className="mb-4 text-gray-700 leading-relaxed">
        The key to success lies not just in selecting the right tools, but in creating an integrated 
        technology ecosystem where systems work together seamlessly to support your business goals. 
        This requires thoughtful planning, strategic implementation, and ongoing management.
      </p>
      
      <p className="mb-6 text-gray-700 leading-relaxed">
        At IT Management Solutions, we help real estate agencies navigate the complex technology 
        landscape with expert guidance, implementation support, and ongoing <Link to="/services/managed-it-services" className="text-itmgmt-bright-blue hover:underline">managed services</Link> tailored 
        to the unique needs of the real estate industry. Whether you're just beginning your technology 
        journey or looking to optimize your existing systems, our team is ready to help you leverage 
        technology for sustainable business growth.
      </p>
      
      <div className="bg-gray-100 p-6 rounded-lg mb-6">
        <h3 className="text-xl font-semibold text-itmgmt-medium-blue mb-3">Ready to Transform Your Real Estate Agency?</h3>
        <p className="mb-4 text-gray-700">
          Contact us today for a free technology assessment and discover how the right IT solutions 
          can take your real estate business to new heights.
        </p>
        <Button asChild>
          <Link to="/contact">Schedule a Consultation</Link>
        </Button>
      </div>
    </section>
  );
};

export default Conclusion;
